import {useState, useEffect, useMemo} from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import './style.css'
import DataTable from 'react-data-table-component'
import axios from 'axios'
import {useDispatch} from 'react-redux'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import {matchConsumerId} from '../../utility'
import DatePicker from 'react-datepicker'
import {Container, Form, Button, Row, Col, Card} from 'react-bootstrap'
import 'react-datepicker/dist/react-datepicker.css'
import {useLocation} from 'react-router'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import {PageTitle} from '../../../../_metronic/layout/core'

export const Recordings = () => {
  const [data, setData] = useState([])
  const [pending, setPending] = useState(true)
  // const [selectedRows, setSelectedRows] = useState([])
  // const [clear, setClear] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [searchR, setSearchResults] = useState([])
  const [dateSearchResults, setDateSearchResults] = useState([])
  const [dates, setDates] = useState({
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    endDate: new Date(),
  })
  const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as any
  const dispatch = useDispatch()

  // const [value, onChange] = useState(new Date())

  const query = useLocation()
  const location = query.search || ''
  const consumerId = location.split('=')[1]

  // const {
  //   user: {consumerId},
  // } = user

  useEffect(() => {
    if (consumerId) {
      matchConsumerId(consumerId, dispatch, auth)
    }
  }, [consumerId, dispatch])

  useEffect(() => {
    getFilesFromApi(dates.startDate, dates.endDate)
  }, [dates.startDate, dates.endDate])

  const getFilesFromApi = async (startDate: Date, endDate: Date) => {
    const apiUrl = `${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/get-recordings/${consumerId}?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;

    return await axios
      .get(apiUrl)
      .then((response) => {
        setData(response.data.files)
        localStorage.setItem('apiUrl', response?.data?.data?.credentials?.apiUrl)
        setPending(false)
        setDateSearchResults(response.data.files) // Assuming API returns already filtered data
      })
  }

  useEffect(() => {
    if (searchValue) {
      let getSearchResults = data.filter(
        (item: any) => item.fileName.toLowerCase().indexOf(searchValue) !== -1
      )
      setSearchResults(getSearchResults)
    } else {
      setSearchResults([]) // Clear search results when searchValue is empty
    }
  }, [searchValue, data])

  const handleDownloadClick = (row: any) => {
    const apiUrl = process.env.REACT_APP_API_URL_BACKEND_LOCAL; // Use the direct environment variable

    if (!apiUrl) {
      console.error('Missing API URL');
      return;
    }

    const fileId = row.fileId;
    const fileName = row.fileName;

    const downloadUrl = `${apiUrl}/file?fileId=${fileId}&fileName=${fileName}`;

    window.open(downloadUrl, '_blank');
  };

  const yesClicked = async (file: any) => {
    const {fileId, fileName} = file

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/delete-file/${consumerId}`,
      {
        data: {
          fileName: fileName,
          fileId: fileId,
          apiUrl: localStorage.getItem('apiUrl'),
        },
      }
    )
    console.log('response', response.status, typeof response.status)
    if (response.status === 200) {
      const filteredData = data.filter((item: any) => {
        return item.fileId !== fileId
      })

      const filteredDataOfSearchResult = data.filter((item: any) => {
        return item.fileId !== fileId
      })
      setSearchResults(filteredDataOfSearchResult)

      setData(filteredData)
      // setClear(!clear)
    } else {
      console.log('Some Error', response)
    }
  }

  const handleDeleteClick = (row: any) => {
    const userConfirmed = window.confirm('Are you sure you want to delete this item?')

    if (userConfirmed) {
      yesClicked(row)
    }
  }

  const searchNow = (e: any) => {
    setSearchValue(e.target.value.toLowerCase().substr(0, 20))
  }

  const columns = useMemo(
    () => [
      {
        name: 'Name', // Changed from 'Time (UTC)' to 'Name' as per Recordings.tsx
        selector: (row: any) => row.fileName.substring(row.fileName.indexOf('/') + 1), // As per Recordings.tsx
        sortable: true,
        grow: 2,
      },
      {
        name: 'Size (in MB)', // As per Recordings.tsx
        selector: (row: any) => (row.size / 1024 / 1024).toFixed(2) + ' Mb', // As per Recordings.tsx
        sortable: true,
      },
      {
        name: 'Created', // As per Recordings.tsx
        selector: (row: any) => new Date(row.uploadTimestamp).toDateString(), // As per Recordings.tsx
        sortable: true,
      },
      {
        name: 'Actions',
        cell: (row: any) => (
          <div className='d-flex align-items-center'>
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id='copy-tooltip'>Copy Link</Tooltip>}
            >
              <CopyToClipboard
                text={`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/file?fileId=${row.fileId}&fileName=${row.fileName}`}
                onCopy={() => alert('Link copied to clipboard!')}
              >
                <Button variant='link' className='p-0 me-2'>
                  <i className='fas fa-copy cursor-pointer' />
                </Button>
              </CopyToClipboard>
            </OverlayTrigger>

            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id='download-tooltip'>Download</Tooltip>}
            >
              <Button variant='link' className='p-0' onClick={() => handleDownloadClick(row)}>
                <i className='fas fa-download cursor-pointer' />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger placement='top' overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}>
              <Button variant='link' className='p-0 ms-2' onClick={() => handleDeleteClick(row)}>
                <i className='fas fa-trash-alt cursor-pointer' />
              </Button>
            </OverlayTrigger>
          </div>
        ),
      },
    ],
    []
  )

  const dataFormat: any = () => {
    if (searchValue) {
      return searchR
    } else {
      return data
    }
  }

  const labelStyles = {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '1rem',
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>Recordings & Transcriptions</PageTitle>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px',
        }}
      >
        <div style={{display: 'flex', alignItems: 'center', width: '70%'}}>
          <label style={labelStyles}>From Date</label>
          <DatePicker
            selected={dates.startDate}
            onChange={(date) => {
              const selectedDate = date as Date;
              const today = new Date();
              if (selectedDate instanceof Date && !isNaN(selectedDate.getTime()) && !(selectedDate > today)) {
                setPending(true); // Set pending to true when date is selected
                setDates({
                  ...dates,
                  startDate: selectedDate,
                });
              } else {
                console.log('Invalid start date selected.');
              }
            }}
            className='form-control form-control-solid w-200px ps-3'
            wrapperClassName='date-picker-input me-4'
            maxDate={new Date()}
          />
          <label style={{...labelStyles, marginLeft: '30px', paddingRight: '0.5rem'}}>To Date</label>
          <DatePicker
            selected={dates.endDate}
            onChange={(date) => {
              const selectedDate = date as Date;
              const today = new Date();
              if (selectedDate instanceof Date && !isNaN(selectedDate.getTime()) && selectedDate <= today) {
                if (selectedDate < dates.startDate) {
                  console.log('End date cannot be before start date.');
                } else {
                  setPending(true); // Set pending to true when date is selected
                  setDates({...dates, endDate: selectedDate});
                }
              } else {
                console.log('Invalid end date selected.');
              }
            }}
            className='form-control form-control-solid w-200px ps-3'
            wrapperClassName='date-picker-input me-4'
            maxDate={new Date()}
          />
        </div>
        <div style={{marginLeft: 'auto'}}>
          <input
            type='text'
            className='form-control'
            name='search'
            value={searchValue}
            onChange={(e) => searchNow(e)}
            placeholder='Search...'
            data-kt-search-element='input'
          />
        </div>
      </div>

      <DataTable
        title={<h4 style={{marginTop: '40px', marginBottom: '40px'}}>Recordings & Transcriptions</h4>}
        data={dataFormat()}
        columns={columns}
        pagination
        striped
        progressPending={pending}
        noDataComponent={
          <div style={{paddingTop: '10px', paddingBottom: '10px'}}>There are no records to display</div>
        }
        progressComponent={
          <div style={{fontSize: '1.35rem'}}>
            <div className='d-flex justify-content-center mb-5'>
              <div className='spinner-border text-primary'>
                <span className='sr-only'>Please wait...</span>
              </div>
            </div>
          </div>
        }
        customStyles={{
          table: {
            style: {
              paddingLeft: '20px',
              paddingRight: '20px',
            },
          },
          headRow: {
            style: {
              backgroundColor: '#f0f0f0',
              minHeight: '40px',
            },
          },
          headCells: {
            style: {
              fontSize: '1rem',
              color: '#495057',
              paddingLeft: '5px',
              paddingRight: '5px',
            },
          },
          cells: {
            style: {
              paddingLeft: '5px',
              paddingRight: '5px',
              fontSize: '0.95rem',
            },
          },
          rows: {
            style: {
              '&:nth-child(even)': {
                backgroundColor: '#f8f9fa',
              },
              minHeight: '45px',
            },
          },
          pagination: {
            style: {
              backgroundColor: '#ffffff',
              color: '#333',
            },
          },
        }}
      />
    </>
  )
}
